import React from 'react';

import GradeIcon from '@mui/icons-material/Grade';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const AddToFavoriteActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <GradeIcon />
    </BaseActionButton>
  );
};

export default AddToFavoriteActionButton;
